import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styles from "./index.module.css";
import { FaUpload, FaClock, FaPrint } from "react-icons/fa";
import { MdCreate, MdUpdate, MdVerified, MdRepeat, MdRepeatOneOn } from "react-icons/md";
import { IoMdDocument } from "react-icons/io";
import { PiCertificateFill } from "react-icons/pi";
import { TbCertificateOff, TbZoomCancelFilled, TbAlertCircle, TbProgress, TbSwitchHorizontal } from "react-icons/tb";

const iconMap = {
    BulkUploadStarted: <FaUpload />,
    BulkUploadFailed: <TbAlertCircle />,
    BulkUploadPartiallyProcessed: <TbProgress />,
    BulkUploadCompleted: <MdVerified />,

    SwitchEntity: <TbSwitchHorizontal />,

    EntityCreate: <MdCreate />,
    EntityUpdate: <MdUpdate />,

    CourseCreate: <MdCreate />,
    CourseUpdate: <MdUpdate />,

    CertificateTypeCreate: <MdCreate />,
    CertificateTypeUpdate: <MdUpdate />,

    CertificateTemplateCreate: <IoMdDocument />,
    CertificateTemplateUpdate: <MdUpdate />,
    CertificateTemplateVersionCreate: <IoMdDocument />,
    CertificateTemplateVersionUpdate: <MdUpdate />,

    CertificatePending: <FaClock />,
    CertificateVerified: <MdVerified />,
    CertificateRePrintWithNewVersion: <MdRepeat />,
    CertificateSentToPrinting: <FaPrint />,
    CertificatePrinted: <IoMdDocument />,
    CertificateIssued: <PiCertificateFill />,
    CertificateReIssued: <MdRepeatOneOn />,
    CertificateCancelled: <TbCertificateOff />,
    CertificateHold: <TbZoomCancelFilled />,
};

function formatDateTime(isoDate) {
    const date = new Date(isoDate);
    const pad = (num) => String(num).padStart(2, "0");

    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ` +
        `${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
}

export default function TimelineDashboard({ data = {} }) {
    return (
        <div className={styles.timeline}>
            <div className={styles.cardTopic}>
            <p className={styles.title}>Recent activities</p>
        </div>
            {data?.data.map((item, index) => (
                <div className={styles["timeline-item"]} key={index}>
                    <div className={styles["timeline-left"]}>
                        <div className={`${styles["timeline-icon"]} ${styles[item.audit_log_event]}`}>
                            {iconMap[item.audit_log_event]}
                        </div>
                    </div>
                    <div className={`${styles["timeline-content"]} ${styles[item.type]}`}><h4 className={`${styles[item.audit_log_event]}`}>
                        {item?.description? item?.description : item.audit_log_event.replace(/([A-Z])/g, ' $1').trim()}
                        {/* Conditional info */}
                        {item.audit_log_event.startsWith("Certificate") && item.certificate_action?.document_ref && (
                            <>: {item?.certificate_action?.document_ref}</>
                        )}

                        {item.audit_log_event.startsWith("Course") && item.course?.name && (
                            <>: {item.course.name}</>
                        )}

                        {item.audit_log_event.startsWith("CertificateType") && item.certificate_type?.name && (
                            <>: {item.certificate_type.name}</>
                        )}

                        {item.audit_log_event.startsWith("CertificateTemplate") && item.certificate_template?.name && (
                            <>: {item.certificate_template.name}</>
                        )}

                        {item.audit_log_event.startsWith("Entity") && item.certificate_entity?.name && (
                            <>: {item.certificate_entity.name}</>
                        )}
                    </h4>
                        <p>Change has been made by <span className={styles.name}>{item.user?.full_name}</span></p>
                        <p>{formatDateTime(item.created_at)}</p>
                    </div>
                </div>
            ))}
        </div>
    );
}
